<template>
  <footer class="footer">
    <p class="copyright" v-html="copyright"></p>
    <div class="link-box">
      <a
        v-if="showCustomize"
        class="customize-link"
        :href="JpServicePrivacy"
        target="_blank"
        >資金決済法に基づく表示</a
      >
      <a
        v-if="showCustomize"
        class="customize-link"
        :href="JpCustomizelink"
        target="_blank"
        >特定商取引法に基づく表示</a
      >
      <a class="service-link" :href="serviceLink" target="_blank">{{
        letter.fwtk
      }}</a>
      <a class="policy-link" :href="privacyLink" target="_blank">{{
        letter.yszc
      }}</a>
      <a
        v-if="paypricyLink && paypricy"
        target="_blank"
        class="policy-link"
        :href="paypricyLink"
        >{{ paypricy }}</a
      >
    </div>
  </footer>
</template>

<script>
import globalConfig from '@utiles/officialStore/globalConfig';
import { getGameLanguage } from '@store/languages/gameConf';
import serviceLink from '@mixins/officialStore/serviceLink';
const mainHost = globalConfig.getMainHost();
import { getCopyright, getPrivacyLink } from '@utiles/reviewFooter';

export default {
  name: 'pageFooter',
  mixins: [serviceLink],
  data() {
    let copyright = `COPYRIGHT © ${location.host.toUpperCase()} ALL RIGHTS RESERVED.`;
    // 2024.08.23 邓智轩：送审域名+对应游戏+带参数p=rupay时替换copyright
    let gameId =
      globalConfig.getHrefParam('gameId') ||
      globalConfig.getHrefParam('game_id') ||
      globalConfig.getHrefParam('gameID') ||
      '';
    return {
      copyright: getCopyright(gameId) || copyright
    };
  },
  computed: {
    privacyLink() {
      const reviewPrivacyLink = getPrivacyLink(this.gameId);
      if (reviewPrivacyLink) {
        return reviewPrivacyLink;
      }
      // 2024.08.08 邓智轩：PNS（191）带参数p=pnsjp时替换隐私协议链接
      if (
        this.$store.state.gameId == 191 &&
        globalConfig.getHrefParam('p') == 'pnsjp'
      ) {
        return `//gpassport.${window.atob('MzdnYW1lcy5jb20=')}/center/JpServicePrivacy/privacy`;
      }
      return `//gpassport.${mainHost}/center/${
        this.isJp ? 'Jp' : ''
      }ServicePrivacy/privacy`;
    },
    JpCustomizelink() {
      // 2024.08.08 邓智轩：PNS（191）带参数p=pnsjp时替换取引法链接
      if (
        this.$store.state.gameId == 191 &&
        globalConfig.getHrefParam('p') == 'pnsjp'
      ) {
        return `https://gpassport.${window.atob('MzdnYW1lcy5jb20=')}/center/JpServicePrivacy/customize?keyWord=quyin_jpapay`;
      }
      return `//gpassport.${window.atob('MzdnYW1lcy5jb20=')}/center/JpServicePrivacy/customize?keyWord=payquyin`;
    },
    JpServicePrivacy() {
      // 2024.08.08 邓智轩：PNS（191）带参数p=pnsjp时替换资金结算法链接更新
      if (
        this.$store.state.gameId == 191 &&
        globalConfig.getHrefParam('p') == 'pnsjp'
      ) {
        return `//gpassport.${window.atob('MzdnYW1lcy5jb20=')}/center/JpServicePrivacy/customize?keyWord=zj_jpapay`;
      }
      return `//gpassport.${window.atob('MzdnYW1lcy5jb20=')}/center/JpServicePrivacy/customize?keyWord=ztmslgzjjsf`;
    },
    letter() {
      return this.$store.state.letter;
    },
    paypricyLink() {
      return getGameLanguage('', 'paypricyLink', this.gameId);
    },
    paypricy() {
      return getGameLanguage('', 'paypricy', this.gameId);
    },
    gameId() {
      return this.$store.state.gameId;
    },
    lang() {
      return this.$store.state.lang;
    },
    showCustomize() {
      return (
        this.gameId === 191 &&
        (this.lang === 'ja-JP' || globalConfig.getHrefParam('p') === 'pnsjp')
      );
    }
  }
};
</script>

<style scoped lang="scss">
.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  background-color: var(--footer-bg);
  padding: 39px 24px;
  box-sizing: border-box;
}
.copyright {
  color: var(--footer);
  text-align: center;
  margin-bottom: 14px;
  font-size: 20px;
  -webkit-text-size-adjust: none;
}

.link-box {
  text-align: center;
  position: relative;
}

.customize-link,
.service-link,
.policy-link {
  display: inline-block;
  margin: 0 10px;
  font-size: 20px;
  color: var(--footer);
  text-align: center;
  text-decoration: none;
  -webkit-text-size-adjust: none;
  cursor: pointer;
}
</style>
